((($) => {

    $.each($('.breaking-news-slider'), function (index, el) {
        let delay = $(el).data('delay');
        if (typeof delay !== 'number') {
            delay = 10000;
        }
        const sliderItem = $(el).find('.breaking-news__item');
        const itemsWrapper = $(el).find('.breaking-news__items');
        const items = $(el).find('.breaking-news__item__text');

        const fixHeight = function () {
            let maxH = 0;
            itemsWrapper.find('.is-visible').removeClass('is-visible')
            items.first().addClass('is-visible')
            items.css('height', 'auto')
            $.each(items, function (j, it) {

                if (it.clientHeight > maxH) {
                    maxH = it.clientHeight;
                }
            });

            sliderItem.css('height', maxH);
            items.css('height', maxH);
            itemsWrapper.css('margin-top', 0);
        }

        setTimeout(function () {
            fixHeight();
        }, 100);

        $(window).on('resize', function () {
            fixHeight();
        });

        if (items.length > 1) {
            let interval = false;
            fixHeight();

            const move = function () {
                const visible = $(el).find('.is-visible');

                let next = [];
                if (!visible.length) {
                    items.first().addClass('is-visible');
                } else {
                    next = visible.next('.breaking-news__item__text');
                }

                let mt = parseFloat(itemsWrapper.css('margin-top'));
                mt = Math.abs(mt);
                let h = 0;
                if (next && next.length) {
                    next.addClass('is-visible');

                    h = next[0].clientHeight;
                    mt += parseFloat(next[0].clientHeight);

                } else {
                    mt = 0;
                    h = items.first().clientHeight;
                    items.first().addClass('is-visible')
                }
                visible.removeClass('is-visible');

                itemsWrapper.css('margin-top', mt * -1);

                if (interval !== false) {
                    clearInterval(interval);
                }
                interval = setInterval(function () {
                    move();
                }, delay);
            }

            setTimeout(function () {
                move();
            }, delay);
        }

    })


    // $.each($('.c-marquee'), function (index, el) {
    //     let speed = $(el).data('speed');
    //     if (typeof speed !== 'number') {
    //         speed = 6;
    //     }
    //     const sliderItem = $(el).find('.c-marquee__box');
    //     const itemsWrapper = $(el).find('.c-marquee__wrapper');
    //     const items = $(el).find('.c-marquee__item');
    //
    //     let latestHeight = 0;
    //     let totalHeight = 50;
    //     const fixHeight = function () {
    //         itemsWrapper.find('.is-visible').removeClass('is-visible')
    //         items.first().addClass('is-visible')
    //         items.css('height', 'auto');
    //         $.each(items, function (j, it) {
    //             let hh = $(it).height() + parseFloat($(it).css('margin-top'));
    //             totalHeight += (hh);
    //             if (j > items.length - 4) {
    //                 latestHeight += hh;
    //             }
    //         });
    //
    //         itemsWrapper.css('height', totalHeight);
    //         itemsWrapper.css('margin-top', 0);
    //     }
    //
    //     $(window).on('resize', function () {
    //         fixHeight();
    //     });
    //
    //     if (items.length > 1) {
    //         let interval = false;
    //         fixHeight();
    //         const move = function () {
    //             itemsWrapper.stop().animate({
    //                 'margin-top': (totalHeight - (latestHeight)) * -1
    //             }, totalHeight * speed, 'linear', function () {
    //                 setTimeout(function () {
    //                     itemsWrapper.stop().animate({
    //                         'margin-top': 10,
    //                     }, totalHeight / 2, function () {
    //                         move();
    //                     });
    //
    //                 }, 1000)
    //             });
    //         }
    //         itemsWrapper.hover(function () {
    //             itemsWrapper.stop();
    //         }, function () {
    //             move();
    //         });
    //
    //         setTimeout(function () {
    //             move();
    //         }, 1000)
    //
    //     }
    //
    // })
})(jQuery));
